var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "-9.5 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iphone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 4h8.281c1.313 0 2.375 1.063 2.375 2.375v19.25c0 1.313-1.063 2.375-2.375 2.375h-8.281c-1.313 0-2.375-1.063-2.375-2.375v-19.25c0-1.313 1.063-2.375 2.375-2.375zM1.531 23.281h9.969v-14.781h-9.969v14.781zM6.5 26.563c0.75 0 1.313-0.563 1.313-1.281 0-0.75-0.563-1.313-1.313-1.313-0.719 0-1.281 0.563-1.281 1.313 0 0.719 0.563 1.281 1.281 1.281z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.253c67d36f7b4e49350340b82d901bfe.svg";
export { ForwardRef as ReactComponent };